const E = function() {
  const O = {
    HEADER: {
      section: "Header"
    },
    PRODUCT_MENU: {
      section: "ProductMenu"
    },
    FOOTER: {
      section: "Footer"
    }
  };
  return Object.keys(O).forEach((o) => O[o].action = "click"), O;
}(), _ = Object.freeze(
  {
    HEADER_SIGN_IN_CLICK: {
      ...E.HEADER,
      component: "Sign In"
    },
    HEADER_CREATE_FREE_ACCOUNT_CLICK: {
      ...E.HEADER,
      component: "Create Free Account"
    },
    HEADER_EMAIL_DROPDOWN_MY_DOCUMENTS_CLICK: {
      ...E.HEADER,
      component: "Email Drop-down",
      extra: "My Documents"
    },
    HEADER_EMAIL_DROPDOWN_MY_ACCOUNT_CLICK: {
      ...E.HEADER,
      component: "Email Drop-down",
      extra: "My Account"
    },
    HEADER_EMAIL_DROPDOWN_ESTATE_VAULT_CLICK: {
      ...E.HEADER,
      component: "Email Drop-down",
      extra: "Estate Vault"
    },
    HEADER_EMAIL_DROPDOWN_SIGN_OUT_CLICK: {
      ...E.HEADER,
      component: "Email Drop-down",
      extra: "Sign Out"
    },
    HEADER_HELP_DROPDOWN_CHAT_ONLINE_CLICK: {
      ...E.HEADER,
      component: "Help Drop-down",
      extra: "Chat Online"
    },
    HEADER_HELP_DROPDOWN_EMAIL_US_CLICK: {
      ...E.HEADER,
      component: "Help Drop-down",
      extra: "Email Us"
    },
    HEADER_HELP_DROPDOWN_HELP_CENTER_CLICK: {
      ...E.HEADER,
      component: "Help Drop-down",
      extra: "Help Center"
    },
    HEADER_COUNTRY_DROPDOWN_CLICK: {
      ...E.HEADER,
      component: "Country Drop-down",
      extra: "<Country name>"
    },
    HEADER_PHONE_NUMBER_CLICK: {
      ...E.HEADER,
      component: "Phone Number"
    },
    HEADER_LAW_DEPOT_CLICK: {
      ...E.HEADER,
      component: "LawDepot"
    },
    PRODUCT_MENU_CATEGORY_CLICK: {
      ...E.PRODUCT_MENU,
      component: "<Component name>"
    },
    PRODUCT_MENU_PRODUCT_CLICK: {
      ...E.PRODUCT_MENU,
      component: "<Category name>",
      extra: "<Product name>"
    },
    PRODUCT_MENU_SEARCH_BAR_CLICK: {
      ...E.PRODUCT_MENU,
      component: "Search Bar",
      extra: "[Search CTA Text]:[User Search Bar Input]"
    },
    FOOTER_HOME_CLICK: {
      ...E.FOOTER,
      component: "Home"
    },
    FOOTER_ABOUT_CLICK: {
      ...E.FOOTER,
      component: "About"
    },
    FOOTER_CONTACT_CLICK: {
      ...E.FOOTER,
      component: "Contact"
    },
    FOOTER_HELP_CENTER_CLICK: {
      ...E.FOOTER,
      component: "Help Center"
    },
    FOOTER_BUSINESS_SOLUTIONS_CLICK: {
      ...E.FOOTER,
      component: "Business Solutions"
    },
    FOOTER_LEGAL_DOCUMENTS_CLICK: {
      ...E.FOOTER,
      component: "Legal Documents"
    },
    FOOTER_RESOURCES_CLICK: {
      ...E.FOOTER,
      component: "Resources"
    },
    FOOTER_AFFILIATE_PROGRAM_CLICK: {
      ...E.FOOTER,
      component: "Affiliate Program"
    },
    FOOTER_WHITE_LABEL_PROGRAM_CLICK: {
      ...E.FOOTER,
      component: "White Label Program"
    },
    FOOTER_TERMS_OF_USE_CLICK: {
      ...E.FOOTER,
      component: "Terms of Use"
    },
    FOOTER_DISCLAIMER_CLICK: {
      ...E.FOOTER,
      component: "Disclaimer"
    },
    FOOTER_PRIVACY_POLICY_CLICK: {
      ...E.FOOTER,
      component: "Privacy Policy"
    },
    FOOTER_COOKIE_POLICY_CLICK: {
      ...E.FOOTER,
      component: "Cookie Policy"
    },
    FOOTER_LEGAL_NOTICE_CLICK: {
      ...E.FOOTER,
      component: "Legal Notice"
    },
    FOOTER_CANCEL_PAGE_CLICK: {
      ...E.FOOTER,
      component: "Cancel Page"
    },
    FOOTER_LAW_LIBRARY_CLICK: {
      ...E.FOOTER,
      component: "Law Library"
    }
  }
);
export {
  _ as TRACKING_EVENTS
};
//# sourceMappingURL=index.js.map
